/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedWorkspacesRouteImport } from './routes/_authenticated/workspaces'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedBosunRouteImport } from './routes/_authenticated/bosun'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects/index'
import { Route as AuthenticatedProjectsWorkspaceUuidNewRouteImport } from './routes/_authenticated/projects/$workspaceUuid.new'
import { Route as AuthenticatedProjectsWorkspaceUuidProjectUuidRouteImport } from './routes/_authenticated/projects/$workspaceUuid.$projectUuid'
import { Route as AuthenticatedProjectsWorkspaceUuidProjectUuidProvisioningRouteImport } from './routes/_authenticated/projects/$workspaceUuid.$projectUuid.provisioning'
import { Route as AuthenticatedProjectsWorkspaceUuidProjectUuidSlackOauthCallbackRouteImport } from './routes/_authenticated/projects/$workspaceUuid.$projectUuid.slack.oauth.callback'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWorkspacesRoute = AuthenticatedWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBosunRoute = AuthenticatedBosunRouteImport.update({
  id: '/bosun',
  path: '/bosun',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsWorkspaceUuidNewRoute =
  AuthenticatedProjectsWorkspaceUuidNewRouteImport.update({
    id: '/projects/$workspaceUuid/new',
    path: '/projects/$workspaceUuid/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsWorkspaceUuidProjectUuidRoute =
  AuthenticatedProjectsWorkspaceUuidProjectUuidRouteImport.update({
    id: '/projects/$workspaceUuid/$projectUuid',
    path: '/projects/$workspaceUuid/$projectUuid',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsWorkspaceUuidProjectUuidProvisioningRoute =
  AuthenticatedProjectsWorkspaceUuidProjectUuidProvisioningRouteImport.update({
    id: '/provisioning',
    path: '/provisioning',
    getParentRoute: () => AuthenticatedProjectsWorkspaceUuidProjectUuidRoute,
  } as any)
const AuthenticatedProjectsWorkspaceUuidProjectUuidSlackOauthCallbackRoute =
  AuthenticatedProjectsWorkspaceUuidProjectUuidSlackOauthCallbackRouteImport.update(
    {
      id: '/slack/oauth/callback',
      path: '/slack/oauth/callback',
      getParentRoute: () => AuthenticatedProjectsWorkspaceUuidProjectUuidRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/account': typeof AuthenticatedAccountRoute
  '/bosun': typeof AuthenticatedBosunRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/workspaces': typeof AuthenticatedWorkspacesRoute
  '/projects/': typeof AuthenticatedProjectsIndexRoute
  '/projects/$workspaceUuid/$projectUuid': typeof AuthenticatedProjectsWorkspaceUuidProjectUuidRouteWithChildren
  '/projects/$workspaceUuid/new': typeof AuthenticatedProjectsWorkspaceUuidNewRoute
  '/projects/$workspaceUuid/$projectUuid/provisioning': typeof AuthenticatedProjectsWorkspaceUuidProjectUuidProvisioningRoute
  '/projects/$workspaceUuid/$projectUuid/slack/oauth/callback': typeof AuthenticatedProjectsWorkspaceUuidProjectUuidSlackOauthCallbackRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/account': typeof AuthenticatedAccountRoute
  '/bosun': typeof AuthenticatedBosunRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/workspaces': typeof AuthenticatedWorkspacesRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/projects/$workspaceUuid/$projectUuid': typeof AuthenticatedProjectsWorkspaceUuidProjectUuidRouteWithChildren
  '/projects/$workspaceUuid/new': typeof AuthenticatedProjectsWorkspaceUuidNewRoute
  '/projects/$workspaceUuid/$projectUuid/provisioning': typeof AuthenticatedProjectsWorkspaceUuidProjectUuidProvisioningRoute
  '/projects/$workspaceUuid/$projectUuid/slack/oauth/callback': typeof AuthenticatedProjectsWorkspaceUuidProjectUuidSlackOauthCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/_authenticated/account': typeof AuthenticatedAccountRoute
  '/_authenticated/bosun': typeof AuthenticatedBosunRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/workspaces': typeof AuthenticatedWorkspacesRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/projects/$workspaceUuid/$projectUuid': typeof AuthenticatedProjectsWorkspaceUuidProjectUuidRouteWithChildren
  '/_authenticated/projects/$workspaceUuid/new': typeof AuthenticatedProjectsWorkspaceUuidNewRoute
  '/_authenticated/projects/$workspaceUuid/$projectUuid/provisioning': typeof AuthenticatedProjectsWorkspaceUuidProjectUuidProvisioningRoute
  '/_authenticated/projects/$workspaceUuid/$projectUuid/slack/oauth/callback': typeof AuthenticatedProjectsWorkspaceUuidProjectUuidSlackOauthCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/login'
    | '/account'
    | '/bosun'
    | '/dashboard'
    | '/workspaces'
    | '/projects/'
    | '/projects/$workspaceUuid/$projectUuid'
    | '/projects/$workspaceUuid/new'
    | '/projects/$workspaceUuid/$projectUuid/provisioning'
    | '/projects/$workspaceUuid/$projectUuid/slack/oauth/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/login'
    | '/account'
    | '/bosun'
    | '/dashboard'
    | '/workspaces'
    | '/projects'
    | '/projects/$workspaceUuid/$projectUuid'
    | '/projects/$workspaceUuid/new'
    | '/projects/$workspaceUuid/$projectUuid/provisioning'
    | '/projects/$workspaceUuid/$projectUuid/slack/oauth/callback'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/callback'
    | '/login'
    | '/_authenticated/account'
    | '/_authenticated/bosun'
    | '/_authenticated/dashboard'
    | '/_authenticated/workspaces'
    | '/_authenticated/projects/'
    | '/_authenticated/projects/$workspaceUuid/$projectUuid'
    | '/_authenticated/projects/$workspaceUuid/new'
    | '/_authenticated/projects/$workspaceUuid/$projectUuid/provisioning'
    | '/_authenticated/projects/$workspaceUuid/$projectUuid/slack/oauth/callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/workspaces': {
      id: '/_authenticated/workspaces'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof AuthenticatedWorkspacesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bosun': {
      id: '/_authenticated/bosun'
      path: '/bosun'
      fullPath: '/bosun'
      preLoaderRoute: typeof AuthenticatedBosunRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$workspaceUuid/new': {
      id: '/_authenticated/projects/$workspaceUuid/new'
      path: '/projects/$workspaceUuid/new'
      fullPath: '/projects/$workspaceUuid/new'
      preLoaderRoute: typeof AuthenticatedProjectsWorkspaceUuidNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$workspaceUuid/$projectUuid': {
      id: '/_authenticated/projects/$workspaceUuid/$projectUuid'
      path: '/projects/$workspaceUuid/$projectUuid'
      fullPath: '/projects/$workspaceUuid/$projectUuid'
      preLoaderRoute: typeof AuthenticatedProjectsWorkspaceUuidProjectUuidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$workspaceUuid/$projectUuid/provisioning': {
      id: '/_authenticated/projects/$workspaceUuid/$projectUuid/provisioning'
      path: '/provisioning'
      fullPath: '/projects/$workspaceUuid/$projectUuid/provisioning'
      preLoaderRoute: typeof AuthenticatedProjectsWorkspaceUuidProjectUuidProvisioningRouteImport
      parentRoute: typeof AuthenticatedProjectsWorkspaceUuidProjectUuidRoute
    }
    '/_authenticated/projects/$workspaceUuid/$projectUuid/slack/oauth/callback': {
      id: '/_authenticated/projects/$workspaceUuid/$projectUuid/slack/oauth/callback'
      path: '/slack/oauth/callback'
      fullPath: '/projects/$workspaceUuid/$projectUuid/slack/oauth/callback'
      preLoaderRoute: typeof AuthenticatedProjectsWorkspaceUuidProjectUuidSlackOauthCallbackRouteImport
      parentRoute: typeof AuthenticatedProjectsWorkspaceUuidProjectUuidRoute
    }
  }
}

interface AuthenticatedProjectsWorkspaceUuidProjectUuidRouteChildren {
  AuthenticatedProjectsWorkspaceUuidProjectUuidProvisioningRoute: typeof AuthenticatedProjectsWorkspaceUuidProjectUuidProvisioningRoute
  AuthenticatedProjectsWorkspaceUuidProjectUuidSlackOauthCallbackRoute: typeof AuthenticatedProjectsWorkspaceUuidProjectUuidSlackOauthCallbackRoute
}

const AuthenticatedProjectsWorkspaceUuidProjectUuidRouteChildren: AuthenticatedProjectsWorkspaceUuidProjectUuidRouteChildren =
  {
    AuthenticatedProjectsWorkspaceUuidProjectUuidProvisioningRoute:
      AuthenticatedProjectsWorkspaceUuidProjectUuidProvisioningRoute,
    AuthenticatedProjectsWorkspaceUuidProjectUuidSlackOauthCallbackRoute:
      AuthenticatedProjectsWorkspaceUuidProjectUuidSlackOauthCallbackRoute,
  }

const AuthenticatedProjectsWorkspaceUuidProjectUuidRouteWithChildren =
  AuthenticatedProjectsWorkspaceUuidProjectUuidRoute._addFileChildren(
    AuthenticatedProjectsWorkspaceUuidProjectUuidRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRoute
  AuthenticatedBosunRoute: typeof AuthenticatedBosunRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedWorkspacesRoute: typeof AuthenticatedWorkspacesRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedProjectsWorkspaceUuidProjectUuidRoute: typeof AuthenticatedProjectsWorkspaceUuidProjectUuidRouteWithChildren
  AuthenticatedProjectsWorkspaceUuidNewRoute: typeof AuthenticatedProjectsWorkspaceUuidNewRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,
  AuthenticatedBosunRoute: AuthenticatedBosunRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedWorkspacesRoute: AuthenticatedWorkspacesRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
  AuthenticatedProjectsWorkspaceUuidProjectUuidRoute:
    AuthenticatedProjectsWorkspaceUuidProjectUuidRouteWithChildren,
  AuthenticatedProjectsWorkspaceUuidNewRoute:
    AuthenticatedProjectsWorkspaceUuidNewRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CallbackRoute: CallbackRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
